import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, VSpacer } from '@nx-smartmonkey/ui';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, LinearScale } from 'chart.js';
import { useMemo } from 'react';
import { useRetrieveActiveProject } from '../../../../../hooks/project/useRetrieveActiveProject';
import Text from '../../../../../react-components/Text';
import { PlanCapacity } from './elements/PlanCapacity';
import { PlanCosts } from './elements/PlanCosts';
import { PlanEmissions } from './elements/PlanEmissions';
import { PlanRoutes } from './elements/PlanRoutes';

// Register the required Chart.js components
ChartJS.register(ArcElement, LinearScale, CategoryScale, BarElement);

type AnalyticsDialogProps = {
  dialogOpen: boolean;
  onClose: () => void;
};

export const AnalyticsDialog = ({ dialogOpen, onClose }: AnalyticsDialogProps) => {
  const { data: activeProject } = useRetrieveActiveProject();

  const sectionsActive = useMemo<{ costs: boolean; emissions: boolean; capacities: boolean }>(
    () => ({
      costs: !!(
        activeProject?.planner.vehicleFieldsHasSpecificField(`price_per_minute`) ||
        activeProject?.planner.vehicleFieldsHasSpecificField(`price_per_distance`)
      ),
      emissions: true,
      capacities: !!(activeProject?.constraints.volume || activeProject?.constraints.weight),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeProject]
  );

  return (
    <RoutalDialog
      open={dialogOpen}
      onCloseDialog={onClose}
      showFooter={false}
      titleContent={<Text variant="h6" intlId="planner.plan_details.analytics.title" />}
      dialogProps={{
        maxWidth: `md`,
        paperProps: {
          style: {
            overflow: `hidden`,
          },
        },
      }}
      contentStyles={{ padding: 0, maxHeight: `calc(100vh - 200px)` }}
      dialogContentWarning={<div></div>}
    >
      <Grid display="flex" flexDirection="column" padding="20px">
        {(sectionsActive.costs || sectionsActive.emissions) && (
          <>
            <Grid display="flex" flexDirection="row">
              {sectionsActive.costs && <PlanCosts />}

              {sectionsActive.costs && sectionsActive.emissions && <HSpacer large />}

              {sectionsActive.emissions && <PlanEmissions />}
            </Grid>

            <VSpacer large />
          </>
        )}

        <PlanRoutes />

        {sectionsActive.capacities && (
          <Grid display="flex" flexDirection="column">
            <VSpacer large /> <PlanCapacity />
          </Grid>
        )}
      </Grid>
    </RoutalDialog>
  );
};
